import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChip, MatChipSet } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { dsDtos, webDtos } from '@vectronic/openApi-admin';
import { TableCollapseService } from '@vectronic/util';
import { CommandContentService } from '../../services/command-content.service';

@Component({
  selector: 'table-datatable-command-content',
  templateUrl: './datatable-command-content.component.html',
  styleUrls: ['./datatable-command-content.component.scss'],
  imports: [MatButtonModule, MatChipSet, MatChip, MatIcon, MatTooltip, CommonModule],
})
export class DatatableCommandContentComponent {
  private tableCollapseService = inject(TableCollapseService);
  private commandContentService = inject(CommandContentService);

  row = input<dsDtos.Command | webDtos.CustomerCommand>();
  parameters = input<dsDtos.Parameter[]>();
  isCompactMode = input(false);

  combinedStrings = computed(() =>
    this.commandContentService.getCombinedStrings(this.row(), this.parameters()),
  );

  showMoreTooltip = computed(() => this.combinedStrings()?.join(', '));

  onClickShowMore(event: MouseEvent) {
    event.stopPropagation();
    if (!this.isExpanded) {
      this.tableCollapseService.setCommandContentIdSelected(this.row().idCommand);
    }
  }

  onClickShowLess(event: MouseEvent) {
    event.stopPropagation();
    if (this.isExpanded) this.tableCollapseService.setCommandContentIdSelected(undefined);
  }

  get isExpanded() {
    return this.tableCollapseService.isCommandContentIdSelected(this.row()?.idCommand);
  }
}
